import { useMediaQuery } from "@/hooks/useMediaQuery";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle } from "@/components/ui/sheet";

/** Dialog no desktop, Drawer (bottom sheet) no celular. */
export function ResponsiveModal({ open, onOpenChange, title, description, children, testid, wide = false }) {
  const isDesktop = useMediaQuery("(min-width: 768px)");

  if (isDesktop) {
    return (
      <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogContent
          data-testid={testid}
          aria-describedby={description ? undefined : "no-description"}
          className={`max-h-[90vh] overflow-y-auto border-white/10 bg-card ${
            wide ? "sm:max-w-4xl" : "sm:max-w-lg"
          }`}
        >
          <DialogHeader>
            <DialogTitle className="font-display text-xl">{title}</DialogTitle>
            {description && <DialogDescription>{description}</DialogDescription>}
          </DialogHeader>
          {children}
        </DialogContent>
      </Dialog>
    );
  }

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        side="bottom"
        data-testid={testid}
        aria-describedby={description ? undefined : "no-description"}
        className="max-h-[92vh] overflow-y-auto rounded-t-2xl border-white/10 bg-card"
      >
        <SheetHeader className="text-left">
          <SheetTitle className="font-display text-xl">{title}</SheetTitle>
          {description && <SheetDescription>{description}</SheetDescription>}
        </SheetHeader>
        <div className="pb-6">{children}</div>
      </SheetContent>
    </Sheet>
  );
}
